import { useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import Icon from '../../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../../Icon/icons.js';
import '../../Icon/helper.js';
import { colors } from '../colors.js';

const FavoriteStar = () => {
  const theme = useTheme();
  return /*#__PURE__*/createElement(Icon, {
    glyph: icons.STAR_FILLED,
    styles: {
      root: {
        color: colors.favoriteStar,
        position: 'absolute',
        top: `${theme.spacing.xxs}px`,
        left: `${theme.spacing.xxs}px`
      }
    },
    size: 16
  });
};

export default FavoriteStar;
